// extracted by mini-css-extract-plugin
export var getCloser = "main-page-module--getCloser--3sFVw";
export var scrollWrap = "main-page-module--scrollWrap--3k8Eo";